import React from 'react';
import { useParams } from 'react-router-dom';
import AdminLayout from '@/components/layout/AdminLayout';
import TwinFloEvolution from '@/components/TwinFloEvolution';

export default function TwinFloEvolutionPage() {
  const { subscriberId } = useParams();

  return (
    <AdminLayout>
      <div className="max-w-6xl mx-auto px-6 py-6" data-testid="twinflo-evolution-page">
        <TwinFloEvolution subscriberId={subscriberId} isStaff={true} />
      </div>
    </AdminLayout>
  );
}
